// An RA's controls -> its pre-job checklist (fixes-2 part 2): no AI - the controls are the assessment's own reviewed text.
// The overarching controls first, then one header per hazard group with a check per control line (existing and additional), then
// the permit and the PPE. Linked both ways: risk_assessments.checklist_id, and the RA's manuals (manual_links) link the checklist too.
import { hazardGroups } from './raStandard.js'

const lines = t => String(t || '').split(/\n|;\s+|(?<=\.)\s+(?=[A-Z])/).map(x => x.replace(/^\s*[-•*]\s*/, '').replace(/\s*\([^()]*\)\s*$/, '').trim()).filter(x => x.length > 2)
export const raChecklistTitle = ra => 'Pre-job checklist: ' + String(ra.activity || ra.Activity || 'risk assessment').trim() + (ra.ra_number || ra['RA Number'] ? ' (' + (ra.ra_number || ra['RA Number']) + ')' : '')
export function checklistFromRa(ra) {
  const steps = [], seen = new Set()
  const add = (text, type = 'check') => { const k = type + ':' + text.toLowerCase(); if (type === 'check' && seen.has(k)) return; seen.add(k); steps.push({ text: text.slice(0, 300), type }) }
  const oc = (Array.isArray(ra.overarching_controls) ? ra.overarching_controls : []).map(x => String(x).trim()).filter(Boolean)
  if (oc.length) { add('Before the job', 'header'); oc.forEach(x => add(x)) }
  for (const g of hazardGroups(ra.hazards || [])) {
    const checks = g.hazards.flatMap(h => [...lines(h.existing_controls), ...lines(h.additional_controls)])
    if (!checks.length) continue
    add(g.category, 'header'); checks.forEach(x => add(x))
  }
  const ppe = (Array.isArray(ra.ppe) ? ra.ppe : []).filter(Boolean)
  if ((ra.permit && !/^none$/i.test(String(ra.permit).trim())) || ppe.length) {
    add('Permit and PPE', 'header')
    if (ra.permit && !/^none$/i.test(String(ra.permit).trim())) add('Permit in place: ' + String(ra.permit).trim())
    if (ppe.length) add('PPE worn: ' + ppe.join(', '))
  }
  add('Everyone involved briefed on the risk assessment')
  add('Signature of the person in charge', 'note')
  return { title: raChecklistTitle(ra), description: 'Made from the controls of risk assessment ' + [ra.ra_number || ra['RA Number'], ra.activity || ra.Activity].filter(Boolean).join(' ') + '.', steps }
}
